/**
 * This will add the appropriate apt-green or apt-orange based on whether the number is positive or negative
 *
 * @type {number} amount The amount to check
 */
export default function NumberToPositiveNegativeClassFilter() {
  return function (amount) {
    return {
      positiveNumber: amount > 0,
      negativeNumber: amount < 0
    };
  };
}
